export default {
  // ========== CustomFab - Tooltips ==========
  navigateTo: 'Navigate to',
  studyPlan: 'Study Plan',
  academicLoad: 'Academic Load',
  curricularMesh: 'Curricular Mesh',
  evaluations: 'Evaluations',
  assessmentByStudent: 'Assessment by Student',
  assessmentReport: 'Assessment Report',
  assessmentOf: 'Assessment of the',
  gradingCenter: 'Grading Center',
  grades: 'Grades',
  gradesOf: 'Grades of the',
  progression: 'Progression of',
  progressionOf: 'Progression of',
  pdaTeacher: 'PDA Teacher',
  paStudent: 'PA Student',
  of: 'of the',
  matterDescription: 'Matter Description',
  evaluation: 'Evaluation',
  learningExperiences: 'Learning Experiences',
  pia: 'PIA',
}
